import axios from 'axios';
import _ from 'lodash';
import { _mediaHeaders } from '../../../projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { ammendTeamName } from '../../../projectSpecific/sports/cnr/reducers/SportsMatchReducer';
import { playoffBracketTypes } from '../../../projectSpecific/sports/elements/matches/PlayoffBracket';
import { _sportLevels } from '../../../projectSpecific/sports/helpers/league';
import { matchCalcs } from '../../../projectSpecific/sports/helpers/match';
import { convertHelpers, getGoogleSheetDataValues, removeEmptyObjectArrays } from '../../common/convert';
import { createRefPath_event } from '../../firestoreData/appData/appRefPaths';
import { createFsDocKey } from '../../firestoreData/appData/fsAppData';
import { filterHelpers } from 'global/common/filtering';

const _useTrib = false
const _useCorsAnywhere = true
const _useSingleDate = false
const singleDate = '02/06/2026'
const singleDates = ['01/31/2026', '02/05/2026', '02/06/2026']

export const mediaHelpers = {
  getMedia_sidearm: (fn_cls, callback) => getMedia_sidearm(fn_cls, callback),
  ammendMedia_season: (database_fns, matches_flat, teams, pathViews, year, _sportsAbr, forPlayoffs, forAlignment, alignments, sectionCounts, mediaSeason) => ammendMediaSeason(database_fns, matches_flat, teams, pathViews, year, _sportsAbr, forPlayoffs, forAlignment, alignments, sectionCounts, mediaSeason),
  createAlignmentsFromMatches: (matches, teams) => createAlignmentsFromMatches(matches, teams),
  createMediaSeason_db: (mediaSeason, createOptions, parentDataKeys, _seasonalId, pathViews, callback) => createMediaSeason_db(mediaSeason, createOptions, parentDataKeys, _seasonalId, pathViews, callback),
  getMedia_results: ({ dateGroupKeys, forPlayoffs, links_score, year, _sportsAbr, teams, forRefresh }, callback) => getMediaResults({ dateGroupKeys, forPlayoffs, links_score, year, _sportsAbr, teams, forRefresh }, callback),
  getMedia_results_pure: (dateGroupKeys, forPlayoffs, links_score, year, _sportsAbr, teams, forRefresh, callback) => getMediaResults_pure(dateGroupKeys, forPlayoffs, links_score, year, _sportsAbr, teams, forRefresh, callback),
  getMedia_alignment: (links_score, year, _sportsAbr, teams, callback) => getMediaAlignment(links_score, year, _sportsAbr, teams, callback),
  getMedia_alignments: (yearCount, links_score, year, _sportsAbr, existingTeams, callback) => getMediaAlignments(yearCount, links_score, year, _sportsAbr, existingTeams, callback),
  getMedia_alignmentAndResults: (pathViews, dateGroupKeys, links_score, year, _sportsAbr, existingTeams, callback) => getMediaAlignmentAndResults(pathViews, dateGroupKeys, links_score, year, _sportsAbr, existingTeams, callback),
  getMedia_wpial: (pathViews, dateGroupKeys, links_score, year, _sportsAbr, existingTeams, callback) => getMedia_wpial(pathViews, dateGroupKeys, links_score, year, _sportsAbr, existingTeams, callback),
}


const getMediaAlignmentAndResults = async (pathViews, dateGroupKeys, links_score, year, _sportsAbr, existingTeams, callback) => {
  const cb_alignments = (results_alignment) => {
    const cb_results = (matches) => {
      const { teams: teams_media, sectionCounts, alignments } = results_alignment
      const mediaSeason = {
        teams: teams_media,
        alignments: alignments
      }
      const _mediaSeason = ammendMediaSeason(matches, existingTeams, pathViews, year, _sportsAbr, false, false, alignments, sectionCounts, mediaSeason)
      callback(_mediaSeason)
    }
    getMediaResults(dateGroupKeys, false, links_score, year, _sportsAbr, existingTeams, true, cb_results)
  }
  // get the results from the media request
  await getMediaAlignment(links_score, year + 1, _sportsAbr, existingTeams, cb_alignments)

}
/**
 * 
 * @param {*} dateGroupKeys 
 * @param {*} forPlayoffs 
 * @param {*} links_score 
 * @param {*} year 
 * @param {*} _sportsAbr 
 * @param {*} existingTeams 
 * @param {*} forRefresh 
 * @param {*} callback 
 */
const getMediaResults = async ({ dateGroupKeys, forPlayoffs, links_score, year, _sportsAbr, existingTeams, forRefresh }, callback) => {
  const callData = { dateGroupKeys, forPlayoffs, links_score, existingTeams, year }
  const mediaResults = await (getMediaScores(callData))
  const _mediaResults = removeEmptyObjectArrays(mediaResults)
  const _resultsNormal = getMergedMatches(_mediaResults, forPlayoffs)
  // mergedMatches, teams, groupedTeams
  const results = {
    mediaResults,
    _mediaResults,
    ..._resultsNormal
  }
  callback(results, forPlayoffs, year, _sportsAbr, forRefresh)
}

const createAlignmentsFromMatches = (ams, existingTeams, database_fns) => {

  const _newTeams = {}

  const generateId = (teamName) => {
    const _teamKey = _.findKey(existingTeams, { name: teamName })
    if (_teamKey) {
      return _teamKey
    } else {
      const newTeamKey = database_fns.get_docKey()
      _newTeams[newTeamKey] = {
        name: teamName
      }
      return newTeamKey
    }
  };

  const _levels = {}

  _.forEach(ams, (am, seasonTypeKey) => { // season/seasonPlayoff

    switch (seasonTypeKey) {

      case 'seasonMatches':

        _.forEach(am, (_levelMatches, levelKey) => {

          switch (levelKey) {
            case 'nonLevel':
            case 'tournament':
              // nothing
              break;

            default:
              _.forEach(_levelMatches, (levelMatch) => {
                const { home, away, sections, levels } = levelMatch
                const _section = _.camelCase(sections)

                const _homeName = ammendTeamName(home)
                const _awayName = ammendTeamName(away)

                if (!matchCalcs.isNon(levels)) {

                  switch (levels) {
                    case _mediaHeaders.tournament:
                      break;

                    default:
                      switch (_section) {
                        case matchCalcs.isNon(_section):
                          break;
                        default:

                          const home_id = generateId(database_fns, _homeName)
                          const away_id = generateId(database_fns, _awayName)

                          if (home_id && away_id) {
                            if (!_levels[levels]) { _levels[levels] = { sections: {} } }
                            if (!_levels[levels].sections[_section]) { _levels[levels].sections[_section] = { teams: {} } }
                            if (!_levels[levels].sections[_section].teams[_homeName]) {
                              _levels[levels].sections[_section].teams[_homeName] = {
                                name: _homeName,
                                id: home_id
                              }
                            }
                            if (!_levels[levels].sections[_section].teams[_awayName]) {
                              _levels[levels].sections[_section].teams[_awayName] = {
                                name: _awayName,
                                id: away_id
                              }
                            }
                          }
                      }
                  }
                }

              })
          }

        })
        break;
      default:
      // nothing
    }


  })


  return _levels

}

const getMergedMatches = (mediaResults, forPlayoffs) => {

  const mergedMatches = _.flatMap(mediaResults);
  const filteredMatches = _.filter(mergedMatches, (match) => match.sections !== _mediaHeaders.nonDistrict);
  const groupedMatches = _.groupBy(filteredMatches, (item) => `${item.levels}_${item.sections}`);

  const teams = []

  Object.keys(groupedMatches).forEach(lsKey => {
    const lsKey_split = lsKey.split('_')
    const levels = lsKey_split[0]
    const sections = lsKey_split[1]
    const matches = groupedMatches[lsKey]
    const homeTeams = _.uniq(_.map(matches, 'home'));
    const awayTeams = _.uniq(_.map(matches, 'away'));
    const _allTeams = _.uniq([...homeTeams, ...awayTeams]);
    _allTeams.forEach(team => {
      teams.push({
        name: team,
        levels: levels,
        sections: sections,
      })
    })
  })

  const groupedTeams = forPlayoffs ? _.groupBy(teams, (item) => `${item.levels}`) : _.groupBy(teams, (item) => `${item.levels}_${item.sections}`);

  return { mergedMatches, teams, groupedTeams }

}

/**
 * 
  // mediaUrl = 'https://hssports.post-gazette.com/sports/25/3-boys-varsity-basketball/schedule/TODAYSDATE/'
 * @param {object} callData 
 * @returns all the results from a media scrape
 * @description loops the `dateGroupKeys` and get the data. Returns a promise when all the dates have been scraped
 */
const getMediaScores = async (callData) => {
  const { dateGroupKeys, links_score, year } = callData
  const _year = year % 100
  let { mediaUrl, mediaUrlYearReplace } = links_score ?? {}
  const _url = mediaUrl && mediaUrlYearReplace ? mediaUrl.replace(mediaUrlYearReplace, _year) : mediaUrl.replace('25', _year)
  const promises = []
  let _dataGroupKeys = _useSingleDate && singleDate ? [singleDate] : dateGroupKeys
  if (_useSingleDate && !_.isEmpty(singleDates)) { _dataGroupKeys = singleDates }
  if (_dataGroupKeys) {
    _dataGroupKeys.forEach(async d => {
      promises.push(getMediaData(d, _url, callData))
    })
  }
  return Promise.all(promises)
}


const getMediaAlignments = async (yearCount, links_score, year, _sportsAbr, existingTeams, callback) => {

  const promises = [];

  // Loop backward for 15 years, adding each call to the promises array
  for (let currentYear = year; currentYear > year - yearCount; currentYear--) {
    promises.push(getMediaStandings(links_score, currentYear, existingTeams));
  }

  // Wait for all promises to resolve
  const results = await Promise.all(promises);

  // Map results to years for better readability
  const allResults = {};
  for (let i = 0; i < yearCount; i++) {
    allResults[year - i] = results[i];
  }

  // Invoke the callback with all results
  callback(allResults, year, _sportsAbr);
}

const getMediaAlignment = async (links_score, year, _sportsAbr, teams, callback) => {
  const results = await getMediaStandings(links_score, year, teams)
  // results, year, _sportsAbr
  callback(results, year, _sportsAbr)
}

function formatDate(inputDate) {
  // Split the input date into components
  var dateComponents = inputDate.split('/');

  // Extract month, day, and year
  var month = dateComponents[0];
  var day = dateComponents[1];
  var year = dateComponents[2];

  // Create a new date in 'yyyy-mm-dd' format
  var formattedDate = year + '-' + month + '-' + day;

  return formattedDate;
}

const getMedia_sidearm = async (fn_cls, callback) => {
  // const { url } = urlDataF ?? {}
  try {
    const url = 'https://pittsburghpanthers.com/sports/womens-volleyball/schedule/2024'
    // const url = 'https://goducks.com/sports/womens-volleyball/schedule'
    const urlDataF = { url: url }
    fn_cls.fetchData(urlDataF).then(response_data => {
      const { result } = response_data
      callback(result)
      const parser = new DOMParser()
      const doc = parser.parseFromString(result, 'text/html')

      const selectors = {
        doc: doc,
        matchesContainer: doc.querySelector('.sidearm-schedule-games-container'),
      }

      selectors._allMatches = selectors?.matchesContainer ? selectors.matchesContainer.querySelectorAll('.sidearm-schedule-game') : null

      const ms = []
      _.forEach(selectors._allMatches, (match) => {
        const isHome = match.classList.contains('home');
        const gameRow = match.querySelector('.sidearm-schedule-game-row')
        if (gameRow) {
          const resultSpans = match.querySelectorAll('.sidearm-schedule-game-result span');
          const opp = match.querySelector('.sidearm-schedule-game-opponent-name')?.textContent.trim() || ''
          const m = {
            home: isHome ? 'pitt' : opp,
            away: isHome ? opp : 'pitt',
            oppDate: match.querySelector('.sidearm-schedule-game-opponent-date')?.textContent.trim() || '',
            result: resultSpans.length > 2 ? resultSpans[2].textContent.trim() : ''
          }
          ms.push(m)
        }
      })
    })
  } catch (error) {
    console.log('error', error)
  }
}

const getMediaLocal_url = async (urlDataF) => {
  const { url } = urlDataF ?? {}
  const response = await axios({
    url: url,
    method: 'get',
    timeout: 15000,
    headers: {
      'Content-Type': 'application/json',
    },
  })
  const { data: responseData } = response;
  const result = await responseData;
  return { success: true, result }
}

const getMedia_wpial = async (links_score, year, existingTeams) => {

  //   linkValues.googleSheetsId = '1ntWkPyKV9DYdwDcBDYshATj2HAfI-iAzYHHV48UYgN0'
  // linkValues.sheetName = '3A Results'

  let { mediaUrl } = links_score ?? {}
  const _year = year % 100
  const { mediaUrlDateReplace, mediaUrlYearReplace } = links_score ?? {}
  let _url = mediaUrl && mediaUrlDateReplace ? mediaUrl.replace('schedule/' + mediaUrlDateReplace, 'standings') : null
  _url = mediaUrl && mediaUrlYearReplace ? _url.replace(mediaUrlYearReplace, _year) : _url.replace('25', _year)

  if (_url) {
    const urlDataF = { url: _url }
    return await getMediaLocal_url(urlDataF).then(response_data => {
      const { result } = response_data ?? {}
      const parser = new DOMParser()
      const doc = parser.parseFromString(result, 'text/html')
      const results = createAlignmentsFromMedia(doc, existingTeams, _url)
      return results
    }).catch(error => {
      console.log('error', error)
      return {}
    })
  }
}

const getMediaStandings = async (links_score, year, existingTeams) => {

  let { mediaUrl } = links_score ?? {}
  const _year = year % 100
  const { mediaUrlDateReplace, mediaUrlYearReplace } = links_score ?? {}
  let _url = mediaUrl && mediaUrlDateReplace ? mediaUrl.replace('schedule/' + mediaUrlDateReplace, 'standings') : null
  _url = mediaUrl && mediaUrlYearReplace ? _url.replace(mediaUrlYearReplace, _year) : _url.replace('25', _year)

  // const _url = mediaUrl && mediaUrlYearReplace ? mediaUrl.replace(mediaUrlYearReplace, _year) : mediaUrl.replace('25', _year)

  // https://hssports.post-gazette.com/sports/25/3-boys-varsity-basketball/schedule/TODAYSDATE/
  // https://hssports.post-gazette.com/sports/25/4-girls-svarsity-basketball/schedule/TODAYSDATE
  // _url = _url.replace('/25/', '/26/')
  if (_url) {
    const urlDataF = { url: _url }
    return await getMediaLocal_url(urlDataF).then(response_data => {
      const { result } = response_data ?? {}
      const parser = new DOMParser()
      const doc = parser.parseFromString(result, 'text/html')
      const results = createAlignmentsFromMedia(doc, existingTeams, _url)
      return results
    }).catch(error => {
      console.log('error', error)
      console.log('_url', _url)
      return {}
    })
  }
}

const getMediaData_pure = async (date, url, callData) => {
  const { links_score } = callData
  const _date = formatDate(date)
  const { mediaUrlDateReplace } = links_score ?? {}
  const _mediaUrlDateReplace = mediaUrlDateReplace || 'TODAYSDATE'
  let _url = url && _mediaUrlDateReplace ? url.replace(_mediaUrlDateReplace, _date) : null
  if (_url) {
    const urlDataF = { url: _url }
    return await getMediaLocal_url(urlDataF).then(response_data => {
      const { result } = response_data ?? {}
      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(result, 'text/html')
        return doc
      } catch (error) {
        console.log('err', error)
        return []
      }
      return result
    }).catch(error => {
      console.log('error', error)
      return {}
    })
  }
}

// if (_useTrib) {
//   if (_useCorsAnywhere) {
//     mediaUrl = 'https://cors-anywhere.herokuapp.com/'
//     mediaUrl += 'https://tribhssn.triblive.com/scores/TODAYSDATE/5/2/All+Schools/'
//   } else {
//     mediaUrl = 'https://tribhssn.triblive.com/scores/TODAYSDATE/5/2/All+Schools/'
//   }
// }

const getMediaData = async (date, url, callData) => {

  const { links_score } = callData
  const _date = formatDate(date)

  const { mediaUrlDateReplace } = links_score ?? {}

  const _mediaUrlDateReplace = mediaUrlDateReplace || 'TODAYSDATE'

  let _url = url && _mediaUrlDateReplace ? url.replace(_mediaUrlDateReplace, _date) : null

  if (_url) {
    const urlDataF = { url: _url }
    try {
      const response_data = await getMediaLocal_url(urlDataF)
      const { result } = response_data ?? {}

      if (!result) return []

      const doc = new DOMParser().parseFromString(result, 'text/html')
      const table = doc.querySelector('table.schedule')

      if (!table) return []

      const trs = table.querySelectorAll('tr')
      const matchData = []

      // 🔑 explicit state — no DOM guessing
      // let currentLevel = null
      // let currentSection = null
      // let currentSpecial = null

      trs.forEach(tr => {

        const matchAttributes = {
          level: null,
          section: null,
          special: null
        }

        // header rows
        if (tr.classList.contains('class-name')) {
          matchAttributes.level = tr.textContent.trim()
          // currentLevel = tr.textContent.trim()
          // currentSection = null
          // currentSpecial = null
          // Class 6A
          return
        }

        if (tr.classList.contains('conference-name')) {
          // currentSection = tr.textContent.trim()
          matchAttributes.section = tr.textContent.trim()
          // Non Conference
          // Tournaments
          // Section 1 (1A)
          // Non Conference
          return
        }

        if (tr.classList.contains('special-game')) {
          matchAttributes.special = tr.textContent.trim()
          // currentSpecial = tr.textContent.trim()
          // Tournament: Shootout at St. Vincent College
          return
        }

        const tds = tr.querySelectorAll('td')
        if (tds.length !== 3) return

        // const _header = {
        //   ...(currentLevel && { level: currentLevel }),
        //   ...(currentSection && { section: currentSection }),
        //   ...(currentSpecial && { special: currentSpecial })
        // }

        const m = getMediaMatch(tds, date, matchAttributes)

        if (_useSingleDate && m?.startDate === singleDate) {
          console.log('match', m)
        }

        if (_useSingleDate && !_.isEmpty(singleDates) && _.includes(singleDates, m?.startDate)) {
          console.log('match', m)
        }

        if (m) {
          matchData.push(m)
        }
      })

      return matchData

    } catch (error) {
      console.log('error', error)
      return []
    }

  } else {
    return {}
  }

  // let urlDataF;

  // switch (sportsModeKey) {
  //   case 'mensFootball':
  //     urlDataF = { url: 'https://hssports.post-gazette.com/sports/25/1-' + sportsModeSport + '/schedule/' + _date + '/' }
  //     break;
  //   case 'mensSoccer':
  //     urlDataF = { url: 'https://hssports.post-gazette.com/sports/25/8-boys-varsity-soccer/schedule/' + _date + '/' }
  //     break;
  //   case 'womensSoccer':
  //     urlDataF = { url: 'https://hssports.post-gazette.com/sports/25/9-girls-varsity-soccer/schedule/' + _date + '/' }
  //     break;
  // } 
}

function getClosest(table, selector) {

  let currentRow = table.previousElementSibling;

  while (currentRow) {
    const classNameTd = currentRow.querySelector(selector);
    if (classNameTd) {
      return classNameTd; // Return the element if found
    }
    currentRow = currentRow.previousElementSibling;
  }

  return null; // Return null if no 'class-name' found
}

function getClosestDiv(tableElement, selector) {
  let currentElement = tableElement.previousElementSibling;

  while (currentElement) {
    // Check if the element is a `div` with the class 'classification-name'
    if (currentElement.classList.contains(selector)) {
      return currentElement.textContent.trim(); // Return the text content if found
    }
    currentElement = currentElement.previousElementSibling;
  }

  return null; // Return null if no 'classification-name' div is found
}

const getClosestStandings = () => {

  let currentRow = row.previousElementSibling;

  while (currentRow) {
    const td = currentRow.querySelector('div.team-top');
    if (td) {
      return td; // Return the element if found
    }
    currentRow = currentRow.previousElementSibling;
  }

  return null; // Return null if no 'class-name' found
}

/**
 * Function to find the closest 'class-name' row above the given row
 * @param {*} row 
 * @returns 
 */
function getClosestLevel(row) {

  let currentRow = row.previousElementSibling;

  while (currentRow) {
    const td = currentRow.querySelector('td.class-name');
    if (td) {
      return td; // Return the element if found
    }
    currentRow = currentRow.previousElementSibling;
  }

  return null; // Return null if no 'class-name' found
}

/**
 * Function to find the closest 'conference-name' row above the given row
 * @param {*} row 
 * @returns 
 */
function getClosestSection(row) {

  let currentRow = row.previousElementSibling;

  while (currentRow) {
    const td = currentRow.querySelector('td.conference-name');
    if (td) {
      return td; // Return the element if found
    }
    currentRow = currentRow.previousElementSibling;
  }

  return null; // Return null if no 'conference-name' found
}

function getClosestSpecial(row) {

  let currentRow = row.previousElementSibling;

  while (currentRow) {
    const td = currentRow.querySelector('td.special-game');
    if (td) {
      return td; // Return the element if found
    }
    currentRow = currentRow.previousElementSibling;
  }

  return null; // Return null if no 'conference-name' found
}

const getLevelFromText = (text) => {
  let sportLevel;
  try {
    _.forEach(_sportLevels, (sl) => {
      if (text.includes(sl)) {
        sportLevel = sl
      }
    })
  } catch (error) {
    console.log('getLevelFromText error', text)
  }
  return sportLevel
}

const getPlayoffLevelFromText = (text) => {

  let sportLevel;
  let isWpial;
  let playoffBracketType;
  try {

    isWpial = text.indexOf('WPIAL') >= 0

    _.forEach(_sportLevels, (sl) => {
      if (text.indexOf(sl) >= 0) {
        sportLevel = sl
      }
    })

    _.forEach(playoffBracketTypes, (pbt) => {
      const _text = text.toLowerCase()
      if (_text.includes(pbt.toLowerCase())) {
        playoffBracketType = pbt
      }
      if (!playoffBracketType && _text.includes('first round')) {
        playoffBracketType = playoffBracketTypes.roundOf16
      }
      if (!playoffBracketType && _text.includes('championship')) {
        playoffBracketType = playoffBracketTypes.finals
      }
      if (!playoffBracketType && _text.includes('consolation')) {
        playoffBracketType = playoffBracketTypes.consolation
      }
      if (!playoffBracketType && _text.includes('preliminary round')) {
        // playoffBracketType = playoffBracketTypes.preliminaryRound
        playoffBracketType = playoffBracketTypes.roundOf32
      }
      if (!playoffBracketType && _text.includes('first round')) {
        // playoffBracketType = playoffBracketTypes.preliminaryRound
        playoffBracketType = playoffBracketTypes.roundOf16
      }
    })
  } catch (error) {
    console.log('getLevelFromText error', text)
  }

  if (!playoffBracketType) {
    console.log('text', text)
  }
  return { sportLevel, isWpial, playoffBracketType }
}

const ammendResults = (match, result) => {

  const _result_s = result.split('-')
  const _result_ot_s = result.split(' ')

  if (_result_s.length === 2) {
    match.awayScore = _result_s[0].trim()
    match.homeScore = _result_s[1].trim()
    if (_result_ot_s.length === 2 && _result_ot_s[1]) {
      match.extra = _result_ot_s[1]
      match.homeScore = match.homeScore.replace(match.extra, '')
      match.homeScore = match.homeScore.trim()
    }
  }
}


/**
 * 
 * @param {boolean} forPlayoffs 
 * @param {object} tds 
 * @param {string} date 
 * @param {string} levels 
 * @param {string} sections 
 * @returns 
 * @description there should be 3 tds: time, teams, and result
 */
const getMediaMatch = (tds, date, matchAttributes) => {

  const _lsp = {
    _matchCollectionKey: _mediaHeaders.tbd,
    level: _mediaHeaders.tbd,
    section: _mediaHeaders.tbd,
    playoff: null,
    playoffBracketType: null,
    exlude: false
  }

  const m = { startDate: date, _header: matchAttributes }

  //   const matchAttributes = {
  //   level: null,
  //   section: null,
  //   special: null
  // }

  const { level, section, special } = matchAttributes

  if (special) {

    // level   
    // Class 6A

    // section
    // Non Conference
    // Tournaments
    // Section 1 (1A)
    // Non Conference

    // special 
    // Tournament: Shootout at St. Vincent College

    const isTournament = special && special.includes('Tournament') && section && section.includes('Tournament')

    if (isTournament) {
      _lsp._matchCollectionKey = _mediaHeaders.tournament
      _lsp.level = _mediaHeaders.tournament
      _lsp.section = _mediaHeaders.tournament
    } else {
      const { sportLevel, isWpial, playoffBracketType } = getPlayoffLevelFromText(special)
      if (isWpial && sportLevel) {
        _lsp.level = sportLevel
        _lsp.section = _mediaHeaders.nonSection
        _lsp.playoffBracketType = playoffBracketType
        _lsp.playoff = playoffBracketType ? true : false
      } else {
        _lsp._exclude = true
      }
    }
  }

  if (level && !special) {
    switch (level) {
      case 'Playoffs':
        _lsp.playoff = true
        break;
      default:
        _lsp.level = getLevelFromText(level)
      // nothing
    }
  }

  if (section && !_lsp.section) {
    switch (section) {
      case 'Non Conference':
        _lsp.level = _mediaHeaders.tbd
        _lsp.section = _mediaHeaders.nonSection
        break;
      case 'Tournament':
      case 'Tournaments':
        // nothing - already set above
        break;
      default:
        _lsp.section = section.replace('(' + _lsp.level + ')', '').trim()
    }
  }

  m._lsp = _lsp

  const teamSplit = _lsp.playoff ? ' vs ' : ' at '

  const startTime = tds[0] ? tds[0].textContent : '7:00 PM'
  const _teams = tds[1] ? tds[1].textContent : null
  const _teams_s = _teams.split(teamSplit)

  let homeName
  let awayName;
  let locationName;

  if (_teams_s.length === 2) {
    awayName = _teams_s[0]
    let _home = _teams_s[1]
    if (_lsp.playoff) {
      const homeSplit = _home.split(' at ')
      homeName = homeSplit[0]
      locationName = homeSplit[1]
    } else {
      homeName = _teams_s[1]
    }

    homeName = ammendTeamName(homeName)
    awayName = ammendTeamName(awayName)

    m.away = awayName
    m.home = homeName

    m._matchCollectionKey = _lsp._matchCollectionKey
    m.sections = _lsp.section
    m.levels = _lsp.level

    m.startTime = startTime

    if (_lsp.playoff) {
      m.isPlayoff = true
      m.roundKey = 'playoffs'
      if (_lsp.playoffBracketType) {
        m.poolKey = _lsp.playoffBracketType
      }
    }

    // ammendMatchLevelAndSectionByMatchTeams(m, teams, awayName, homeName, locationName)
    const _result = tds[1] ? tds[2].textContent.trim() : null

    if (_result) {
      if (_result === 'PPD') {
        return null
      } else {
        ammendResults(m, _result)
      }
    }
  }

  if (m._lsp.level !== m.levels) {
    console.log('mismatch', m)
  }

  return _lsp._exclude ? null : m
}

const generateId = (database_fns, teams, team, _newTeams) => {
  const { name } = team
  const _teamKey = _.findKey(teams, { name: name })
  if (_teamKey) {
    return _teamKey
  } else {
    const newTeamKey = database_fns.get_docKey()
    _newTeams[newTeamKey] = {
      name: name
    }
    return newTeamKey
  }
};

/**
 * ammends the sections prop to camelCase
 * @param {object} matches 
 */
const ammendMatch_sections_cc = (matches) => {
  // ammend the sections
  _.forEach(matches, (match) => {
    if (match.sections) {
      match.sections = _.camelCase(match.sections)
    }
  })
}

const getUniqueTeams = (matches) => {

  const exclusions = ['nonSection', 'tournament', 'nonConference', 'unknown', 'null']

  const _sectionMatches = _.filter(matches, (match) => match.sections &&
    (!exclusions.includes(match.sections) &&
      !match.isPlayoff &&
      !match.sections.startsWith('city')));

  const teams_unique = _.uniqBy(
    _.flatMap(_sectionMatches, (match) => {
      const _home = ammendTeamName(match.home)
      const _away = ammendTeamName(match.away)
      const _teams = [
        { name: _home, sections: _.camelCase(match.sections), levels: match.levels },
        { name: _away, sections: _.camelCase(match.sections), levels: match.levels },
      ];
      return _teams;
    }),
    'name' // Ensure uniqueness by the team name
  );
  return teams_unique
}

const removeMatchesWithNoTeams = (matches, uniqueTeams) => {
  _.remove(matches, (m) => {
    const { home, away } = m;
    const _home = _.find(uniqueTeams, { name: home });
    const _away = _.find(uniqueTeams, { name: away });
    return !_home || !_away; // Remove the match if either team doesn't exist
  });
}

const removeMatchesWithNoTeams2 = (matches, uniqueTeams) => {
  const matchesCopy = [...matches]; // Clone original matches array

  const removedMatches = _.remove(matches, (m) => {
    const { home, away } = m;
    const _home = _.find(uniqueTeams, { name: home });
    const _away = _.find(uniqueTeams, { name: away });
    return !_home || !_away; // Remove the match if either team doesn't exist
  });

  return removedMatches; // Return the removed matches
};

const ammendMatchLevels = (matches_flat, uniqueTeams, existingTeams) => {

  const matches_levels = _.groupBy(matches_flat, 'levels')

  // ammend the levels prop for the match
  // if the teams have the same levels, set the match.levels = to the home.levels setting
  _.forEach(matches_levels, (ms, levelKey) => {

    switch (levelKey) {
      case _mediaHeaders.tournament:
        break;
      case _mediaHeaders.tbd:
        // modify the tbds...
        _.forEach(ms, (match_flat) => {

          const { home, away } = match_flat
          const _home = _.find(uniqueTeams, { name: home })
          const _away = _.find(uniqueTeams, { name: away })
          const _home_existing = _.find(existingTeams, { name: home })
          const _away_existing = _.find(existingTeams, { name: away })

          const _isMissingHomeOrAway = (!_home && _away) || (_home && !_away)

          // if (away.includes('vs')) {
          //   console.log('match_flat a', match_flat)
          // }

          // if (home.includes('vs')) {
          //   console.log('match_flat h', match_flat)
          // }


          // if the
          if (_home && _away) {
            const _sameLevel = _home.levels && _away.levels && (_home.levels === _away.levels)
            const _sameSection = _sameLevel && (_home.sections && _away.sections && (_home.sections === _away.sections))
            if (_sameLevel) {
              match_flat.levels = _home.levels
              match_flat.sections = _sameSection ? _home.sections : _mediaHeaders.nonSection
              match_flat._matchCollectionKey = _sameSection ? _home.levels : _mediaHeaders.nonSection
            } else {
              match_flat.levels = _mediaHeaders.nonLevel
              match_flat.sections = _mediaHeaders.nonSection
              match_flat._matchCollectionKey = _mediaHeaders.nonLevel
            }
          } else {
            if (_isMissingHomeOrAway) {
              match_flat.levels = _mediaHeaders.nonLevel
              match_flat.sections = _mediaHeaders.nonSection
              match_flat._matchCollectionKey = _mediaHeaders.nonDistrict
            }
          }

          if (!_home_existing || !_away_existing) {
            match_flat.levels = _mediaHeaders.nonLevel
            match_flat.sections = _mediaHeaders.nonSection
            match_flat._matchCollectionKey = _mediaHeaders.nonDistrict
          }

        })

        break;

      default:
        try {
          _.forEach(ms, (m) => {
            m._matchCollectionKey = m.levels
          })
        } catch (error) {
          console.log('e', error)
        }

    }
  })

}

const ammendSeasonAlignments = (database_fns, uniqueTeams, existingTeams) => {
  const seasonAlignments = {}
  const newTeams = {}
  const _levelAlignments = _.groupBy(uniqueTeams, 'levels')
  _.forEach(_levelAlignments, (_levelAlignment, levelKey) => {
    seasonAlignments[levelKey] = { sections: {} }
    const _sectionAlignments = _.groupBy(_levelAlignment, 'sections')
    _.forEach(_sectionAlignments, (sectionTeams, sectionKey) => {
      const _sectionKey = _.camelCase(sectionKey)
      seasonAlignments[levelKey].sections[_sectionKey] = { teams: {} }
      _.forEach(sectionTeams, (team, teamKey) => {
        const teamId = generateId(database_fns, existingTeams, team, newTeams)
        seasonAlignments[levelKey].sections[_sectionKey].teams[team.name] = { ...team, id: teamId }
      })
    })
  })
  return { seasonAlignments, newTeams }
}

const getSeasonInfoFromMediaMatches = (database_fns, matches_flat, existingTeams, mediaSeason) => {

  const useSeasonTeams = true

  const uniqueTeams = useSeasonTeams && mediaSeason.teams ? _.values(mediaSeason.teams) : getUniqueTeams(matches_flat)

  ammendMatchLevels(matches_flat, uniqueTeams, existingTeams)

  const { seasonAlignments, newTeams } = ammendSeasonAlignments(database_fns, uniqueTeams, existingTeams)

  const seasonTeams = getTeamsFromAlignment(seasonAlignments)

  const _matches_split = _.mapKeys(
    _.groupBy(matches_flat, 'isPlayoff'),
    (_, key) => (key === 'true' ? 'seasonPlayoffMatches' : 'seasonMatches')
  );
  console.group('getSeasonInfoFromMediaMatches')
  console.log('matches_flat', matches_flat)
  console.log('seasonTeams', seasonTeams)

  const matchGroups = {} // grouped by  seasonMatches, playoffMatches then _matchCollectionKey

  _.forEach(_matches_split, (sms, mtKey) => {
    const gms = _.groupBy(sms, '_matchCollectionKey')
    delete gms.null
    delete gms.undefined
    matchGroups[mtKey] = gms
  })

  console.log('seasonAlignments', seasonAlignments)

  const sectionCounts = getSectionCountsFromTeams(seasonTeams)

  const _matchGroups = createSeasonMatchesFromMedia(database_fns, matchGroups, seasonTeams, existingTeams)

  console.log('matchGroups', matchGroups)
  console.log('_matchGroups', _matchGroups)
  console.groupEnd()

  const { sectionDates, seasonStartDate, seasonEndDate } = getSectionDatesFromAlignment(seasonAlignments, matches_flat)

  const details = { seasonStartDate, seasonEndDate }

  return {
    details,
    matchGroups: _matchGroups,
    newTeams,
    seasonAlignments,
    seasonTeams,
    sectionCounts,
    sectionDates,
    teamCount: _.size(uniqueTeams),
    uniqueTeams,
  }

}

const ammendMediaSeason = (database_fns, matches_flat, existingTeams, pathViews, year, _sportsAbr, forPlayoffs, forAlignment, alignments, sectionCounts, mediaSeason) => {

  const parentKeys = {
    organizations: pathViews.organizations,
    districts: pathViews.districts,
    sports: pathViews.sports,
    sportsYears: year,
  }

  console.log('existingTeams', existingTeams)
  console.log('alignments', alignments)
  console.log('mediaSeason', mediaSeason)

  if (forAlignment) {
    const _mediaSeason = {
      _sportsAbr,
      alignmentOnly: true,
      alignments,
      parentKeys,
      sectionCounts: sectionCounts,
      sportsYear: year,
      teams: existingTeams,
    }
    return _mediaSeason
  } else {

    ammendMatch_sections_cc(matches_flat)

    const seasonInfo = getSeasonInfoFromMediaMatches(database_fns, matches_flat, existingTeams, mediaSeason)

    const { matchGroups } = seasonInfo
    if (forPlayoffs) {
      const { seasonPlayoffMatches } = createSeasonMatchesFromMedia(matchGroups, existingTeams)
      const _mediaSeason = {
        matches_playoffs: seasonPlayoffMatches,
      }
      return _mediaSeason
    } else {
      const _mediaSeason = {
        _alignmentsFromMatches: mediaSeason && mediaSeason.alignments ? false : true,
        _sportsAbr,
        _teamsFromMatches: mediaSeason && mediaSeason.teams ? false : true,
        sportsYear: year,
        parentKeys,
        ...seasonInfo,
      }
      return _mediaSeason
    }
  }

}

const getSectionAndLevel = (seasonTypeKey, levelMatch, levelKey, home, away, home_existing, away_existing) => {

  let match_level;
  let match_section;
  let _matchCollectionKey;

  const _sameLevel = home.levels && away.levels && (home.levels === away.levels)
  const _sameSection = _sameLevel && (home.sections && away.sections && (home.sections === away.sections))

  switch (levelKey) {
    case _mediaHeaders.playoff:
      match_section = levelKey
      match_level = levelKey
      _matchCollectionKey = levelKey
      break;

    case _mediaHeaders.tournament:
      match_section = levelKey
      match_level = levelKey
      _matchCollectionKey = levelKey
      break;

    default:
      if (home_existing && away_existing && !home_existing || !away_existing) {
        _matchCollectionKey = _mediaHeaders.nonDistrict
        match_level = _mediaHeaders.nonLevel
        match_section = _mediaHeaders.nonSection
      } else {
        // are the levels the same?
        if (_sameLevel) {
          // levels are the same!
          match_level = home.levels
          // are the sections the same
          if (_sameSection) {
            match_section = home.sections
            _matchCollectionKey = home.levels
          } else {
            match_section = _mediaHeaders.nonSection
            _matchCollectionKey = _mediaHeaders.nonSection
          }
        } else {
          match_level = _mediaHeaders.nonLevel
          match_section = _mediaHeaders.nonSection
          _matchCollectionKey = _mediaHeaders.nonLevel
        }
      }
  }

  if (seasonTypeKey === "seasonPlayoffMatches") {
    _matchCollectionKey = home.levels
  }

  return { match_level, match_section, _matchCollectionKey }

}

const createSeasonMatchesFromMedia = (database_fns, matchGroups, _teams, existingTeams) => {

  // matchGroups are grouped by _matchCollectionKey
  // these are still flat matches 

  // matchGroups ; {seasonMatches, seasonPlayoffMatches}

  const _matchGroups = {
    matches: {},
    matches_playoffs: {},
    seasonMatches: {},
    seasonPlayoffMatches: {},
    teamMatches: {},
    team_matches: {}
  }

  _.forEach(matchGroups, (matchGroup, seasonTypeKey) => { // seasonMatches, seasonPlayoffMatches

    _.forEach(matchGroup, (matchGroupItem, levelKey) => { // 1A, 2A, nonSection, tournament

      _.forEach(matchGroupItem, (levelMatch) => { // these are FLAT matches

        const { home, away, startDate, homeScore, awayScore, sections, poolKey, roundKey, _matchCollectionKey: mck } = levelMatch

        let _home = _.find(_teams, { name: home })
        let _away = _.find(_teams, { name: away })

        if (!_home) { _home = { name: home } }
        if (!_away) { _away = { name: away } }

        if (_home && _away) {

          const _home_match = _.cloneDeep(_home)
          const _away_match = _.cloneDeep(_away)

          const _home_existing = _.find(existingTeams, { name: home })
          const _away_existing = _.find(existingTeams, { name: away })

          const _homeKey = _.findKey(_teams, { name: home })
          const _awayKey = _.findKey(_teams, { name: away })

          const { match_level, match_section, _matchCollectionKey } = getSectionAndLevel(seasonTypeKey, levelMatch, levelKey, _home_match, _away_match, _home_existing, _away_existing)

          delete _home_match.parentKeys
          delete _home_match._itemKey
          delete _home_match.position
          delete _away_match.parentKeys
          delete _away_match._itemKey
          delete _away_match.position

          const _match = {
            home: _home_match,
            away: _away_match,
            levels: match_level,
            sections: match_section,
            startDate,
            startTime: '6:00 PM',
            teams: [],
            _matchCollectionKey: _matchCollectionKey,
          }

          if (match_level === _mediaHeaders.nonSection) {
            console.log('_match *********************', _match)
          }

          if (_homeKey) {
            _match.home.id = _homeKey
            _match.teams.push(_homeKey)
          }

          if (_awayKey) {
            _match.away.id = _awayKey
            _match.teams.push(_awayKey)
          }

          if (homeScore && awayScore) {
            _match.results = {
              score: {
                home: parseInt(homeScore),
                away: parseInt(awayScore)
              }
            }
          }

          if (seasonTypeKey === 'seasonPlayoffMatches') {
            _match.isPlayoff = true
            if (poolKey) {
              _match.poolKey = poolKey
            }
            if (roundKey) {
              _match.roundKey = roundKey
            }
          }

          const mlk = _matchCollectionKey ? _matchCollectionKey : match_level

          convertHelpers.createNestedObject(_matchGroups[seasonTypeKey], [mlk]);
          convertHelpers.createNestedObject(_matchGroups.teamMatches, [home, seasonTypeKey, mlk], true);
          convertHelpers.createNestedObject(_matchGroups.teamMatches, [away, seasonTypeKey, mlk], true);

          _matchGroups.teamMatches[away][seasonTypeKey][mlk].push(_match)
          _matchGroups.teamMatches[home][seasonTypeKey][mlk].push(_match)


          if (_home_existing) {
            convertHelpers.createNestedObject(_matchGroups.team_matches, [_home_existing._itemKey, seasonTypeKey, mlk], true);
            _matchGroups.team_matches[_home_existing._itemKey].name = _home_existing.name
            _matchGroups.team_matches[_home_existing._itemKey][seasonTypeKey][mlk].push(_match)
          }

          if (_away_existing) {
            convertHelpers.createNestedObject(_matchGroups.team_matches, [_away_existing._itemKey, seasonTypeKey, mlk], true);
            _matchGroups.team_matches[_away_existing._itemKey].name = _away_existing.name
            _matchGroups.team_matches[_away_existing._itemKey][seasonTypeKey][mlk].push(_match)
          }


          const matchKey = database_fns.get_docKey()

          if (_match.isPlayoff) {
            _matchGroups.matches_playoffs[matchKey] = _match
          } else {
            _matchGroups.matches[matchKey] = _match

          }

          _matchGroups[seasonTypeKey][mlk][matchKey] = _match

        } else {

        }
      })
    })
  })


  return _matchGroups

}

const getSectionDatesFromAlignment = (alignments, matches) => {

  const { earliest, latest } = filterHelpers.getEarliestAndLatestDates(matches)

  const sectionDates = {}
  const seasonStartDate = earliest
  const seasonEndDate = latest

  _.each(alignments, (level, levelKey) => {
    switch (levelKey) {
      case 'tournament':
      case 'nonDistrict':
        break;
      default:
        const { sections } = level
        _.each(sections, (section, sectionKey) => {
          // if (sectionKey.startsWith('section')) {
          const { teams } = section
          const teamsCount = _.size(teams)
          if (!sectionDates[teamsCount]) { sectionDates[teamsCount] = [] }
          _.each(teams, (team, teamKey) => {
            const { name, levels, sections } = team
            const teamMatches = _.filter(matches, m => (m.away === name || m.home === name) && (m.sections === sections) && (m.levels === levels));
            const startDates = _.map(teamMatches, 'startDate');
            sectionDates[teamsCount] = startDates
          })
          // }
        })
    }
  })
  return { sectionDates, seasonStartDate, seasonEndDate }
}

const getTeamsFromAlignment = (alignments) => {
  const _teams = {}
  _.forEach(alignments, (level, levelKey) => {
    const { sections } = level
    _.forEach(sections, (section, sectionKey) => {
      const { teams } = section
      const _teamsS = _.sortBy(teams, 'name')
      let position = 0
      _.forEach(_teamsS, (team, teamKey) => {
        if (team.id === undefined || team.id === 'undefined') {
          const teamKey = database_fns.get_docKey()
          team.newTeamKey = teamKey
          team.id = teamKey
        }
        team.levels = levelKey
        team.sections = sectionKey
        team.position = position
        team.name = ammendTeamName(team.name)
        _teams[team.id] = team
        delete _teams[team.id].id
        position++
      })
      // }
    })
  })
  return _teams
}

const getSectionCountsFromTeams = (teams) => {
  // Group by level and count unique sections starting with 'section' for each level
  return _(teams)
    .groupBy('levels')
    .mapValues(levelTeams =>
      _(levelTeams)
        // .filter(team => team.sections.startsWith('section')) // Include only sections that start with 'section'
        .uniqBy('sections')
        .size()
    )
    .value();
};


const createMediaSeason_db = (mediaSeason, createOptions, parentDataKeys, _seasonalId, pathViews, callback) => {

  const {
    _sportsAbr,
    details,
    newTeams,
    parentKeys,
    seasonMatches,
    seasonPlayoffMatches,
    seasonTeams,
    sectionCounts,
    sectionDates,
    sportsYear,
  } = mediaSeason

  const prefix = _sportsAbr + '_' + sportsYear + '_'

  const _seasonalKey = _seasonalId

  const _docKeys = { seasonal: '', matches: '', teams: '' }

  if (_seasonalId) {
    _docKeys.seasonal = _seasonalKey
    _docKeys.matches = parentDataKeys && parentDataKeys.matches ? parentDataKeys.matches : prefix + database_fns.get_docKey()
    _docKeys.teams = parentDataKeys && parentDataKeys.teams ? parentDataKeys.teams : prefix + database_fns.get_docKey()
  } else {
    _docKeys.seasonal = prefix + database_fns.get_docKey()
    _docKeys.matches = prefix + database_fns.get_docKey()
    _docKeys.teams = prefix + database_fns.get_docKey()
  }

  const _allows = {
    seasonal: createOptions.seasonal,
    teams: createOptions.teams,
    seasonalMatches: createOptions.matches,
    seasonalPlayoffMatches: createOptions.matches,
  }

  // update a _seasonals document
  const dataToUpdate_seasonal = { parentKeys }

  if (details) {
    dataToUpdate_seasonal.details = details
  }

  if (sectionCounts) {
    dataToUpdate_seasonal.sectionCounts = sectionCounts
  }

  if (!_.isEmpty(sectionDates)) {
    dataToUpdate_seasonal.sectionDates = sectionDates
  }

  if (seasonTeams) {
    dataToUpdate_seasonal.teams = seasonTeams
  }

  const _refs = {
    seasonal: createRefPath_event(pathViews, ['_seasonals', _docKeys.seasonal]),
    teams: createRefPath_event(pathViews, ['_teams', _docKeys.teams]),
    matches: createRefPath_event(pathViews, ['_matches_seasonal', _docKeys.matches])
  }

  if (_allows.seasonal) {

    if (_allows.teams) {
      if (!_.isEmpty(newTeams)) {
        _.forEach(newTeams, (newTeam, newTeamKey) => {
          const { name } = newTeam
          const _team = {
            name: name,
            parentKeys
          }
          const ref_team = createRefPath_event(pathViews, ['teams', newTeamKey])
          database_fns.set_doc(ref_team, _team)
        })
      }
    }

    // update _teams document
    database_fns.doc_set(_refs.seasonal, dataToUpdate_seasonal).then(res1 => {

      if (_allows.teams) {

        const dateToUpdate_teams = { parentKeys, teams: seasonTeams }

        // update _teams document
        database_fns.doc_set(_refs.teams, dateToUpdate_teams).then(res1 => {

          if (_allows.seasonalMatches) {
            const dataToUpdate_matches = { parentKeys }
            // update _matches_seasonal document
            database_fns.doc_set(_refs.matches, dataToUpdate_matches).then(rez => {
              updateSeasonMatches(seasonMatches, pathViews, _docKeys.matches).then(rezz1 => {
                updateSeasonMatches(seasonPlayoffMatches, pathViews, _docKeys.matches, true).then(rezz1 => {
                  callback()
                })
              })
            })
          } else {
            callback()
          }
        })
      } else if (_allows.seasonalMatches) {
        const dataToUpdate_matches = { parentKeys }
        // update _matches_seasonal document
        database_fns.doc_set(_refs.matches, dataToUpdate_matches).then(rez => {
          updateSeasonMatches(seasonMatches, pathViews, _docKeys.matches).then(rezz1 => {
            updateSeasonMatches(seasonPlayoffMatches, pathViews, _docKeys.matches, true).then(rezz1 => {
              callback()
            })
          })
        })
      } else {
        callback()
      }
    })
  } else {
    console.log('_refs', _refs)
    callback()
  }
}

const updateSeasonMatches = (seasonOrPlayoffMatches, pathViews, _seasonalMatchesDocKey, forPlayoffs) => {

  const matchDocKey = forPlayoffs ? 'playoffMatches' : 'matches'

  const promises = _.map(seasonOrPlayoffMatches, async (levelMatches, levelKey) => {
    const dataToUpdateD = forPlayoffs ? { playoffMatches: levelMatches } : { matches: levelMatches };
    const _ref_seasonalMatches_matches = createRefPath_event(pathViews, ['_matches_seasonal', _seasonalMatchesDocKey, matchDocKey, levelKey]);
    // Return the promise for each document update
    const rez = await database_fns.doc_set(_ref_seasonalMatches_matches, dataToUpdateD);
    return rez;
  });

  // Return a promise that resolves when all updates are complete
  return Promise.all(promises);
};

const updateGsTeams = (teams, year) => {
  const _csv_matchPlayoff = ['id', 'name', 'wins', 'losses', 'ties']
  const records = []
  _.forEach(teams, (team, teamName) => {
    const { record } = team
    record.name = teamName
    records.push(record)
  })
  const _records = _.sortBy(records, 'name')
  const { values } = getGoogleSheetDataValues(_records, _csv_matchPlayoff, 'Football Team Records', year)
  // fn_cls.updateGoogleSheetValues('1Yr8eDE8_Nq4HsOnTkmxe93z2DRGw0uzffBWYr8CzVjA', 'Football Team Records - ' + year, values)
}

function createAlignmentsFromMedia(document, existingTeams, _url) {

  const alignments = {};
  const teamRecords = {}
  const teams = {}
  const nonTeams = []
  let sportsYearStandings;

  document.querySelectorAll('.sport').forEach((sport) => {
    const _standings = sport.querySelectorAll('.team-top')
    if (_standings) {
      const header = sport.querySelectorAll('h2')
      try {
        if (header && header[0]) {
          sportsYearStandings = header[0].textContent.split(' ')[0]
          sportsYearStandings = sportsYearStandings.split('-')[1]
        }
      } catch (error) {
        console.log('error', error)
      }
    }
    sport.querySelectorAll('.standings').forEach((standingsDiv) => {
      standingsDiv.querySelectorAll('table').forEach((table) => {
        let _district = getClosestDiv(table, 'district-name');
        switch (_district) {
          case 'WPIAL':
            let _level = getClosestDiv(table, 'classification-name');
            let _section = getClosestDiv(table, 'conference-name');
            if (_level && _section) {

              _level = _level.replace('Class ', '')
              _section = _section.replace('(' + _level + ')', '')
              _section = _.camelCase(_section)

              table.querySelectorAll('tbody').forEach((tbody) => {
                tbody.querySelectorAll('tr').forEach((tr) => {

                  let team;
                  let _itemKey;

                  tr.querySelectorAll('td').forEach((td, index) => {
                    switch (index) {
                      case 0:
                        team = td.textContent.trim()
                        team = ammendTeamName(team)

                        const _team = _.find(existingTeams, { name: team })
                        _itemKey = _team ? _team._itemKey : database_fns.get_docKey()

                        teamRecords[_itemKey] = {
                          name: team,
                          [sportsYearStandings]: {
                            record: '',
                            overallRecord: '',
                            section: _section,
                            level: convertHelpers.compactText(_level)
                          }
                        }

                        if (!alignments[_level]) { alignments[_level] = { sections: {} } }
                        if (!alignments[_level].sections[_section]) { alignments[_level].sections[_section] = { teams: {} } }
                        if (_team) {
                          alignments[_level].sections[_section].teams[_team.name] = {
                            name: _team.name,
                            _itemKey: _itemKey,
                            exists: true
                          }
                        } else {
                          alignments[_level].sections[_section].teams[team] = {
                            name: team,
                            _itemKey: _itemKey
                          }
                          nonTeams.push(team)
                        }
                        break;
                      case 1:
                        const r = td.textContent.trim()
                        teamRecords[_itemKey][sportsYearStandings].record = r
                        break;
                      case 3:
                        const ro = td.textContent.trim()
                        teamRecords[_itemKey][sportsYearStandings].overallRecord = ro
                        break;
                      default:
                    }

                  })
                })
              })
            }
            break;
          default:
          // nothing
        }
      })
    })
  })

  _.forEach(alignments, (alignment, levelKey) => {
    const { sections } = alignment
    _.forEach(sections, (section, sectionKey) => {
      const { teams: teams_section } = section
      let position = 0
      _.forEach(teams_section, (team, teamKey) => {
        const { name, _itemKey } = team
        teams[_itemKey] = {
          name,
          sections: sectionKey,
          levels: levelKey,
          position
        }
        position++
      })
    })
  })

  const sectionCounts = getSectionCountsFromTeams(teams)

  return { sportsYearStandings, alignments, sectionCounts, teams, teamRecords, nonTeams, _url }
} 